import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RaviSliderComponent } from './ravi-slider/ravi-slider.component';
import { RaviNavbarComponent } from './ravi-navbar/ravi-navbar.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { GalleryComponent } from './gallery/gallery.component';
import { FadeInDirectiveDirective } from './directives/fade-in-directive.directive';
import { ContactformComponent } from './contactform/contactform.component';
import { FooterComponent } from './footer/footer.component';
import { HomeServicesComponent } from './home-services/home-services.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HashLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { GalleryModule, GALLERY_CONFIG } from 'ng-gallery';
import { LightboxModule, LIGHTBOX_CONFIG } from  'ng-gallery/lightbox';
import { WorkComponent } from './work/work.component';
import { NgOpengalleryModule } from 'ng-opengallery';
import { Angular2ImageGalleryModule } from 'angular2-image-gallery';
import { NgxPhotoswipeModule } from 'ngx-photoswipe';
import { SplitPipe, RestPipe, TruncatePipe } from './pipes/split.pipe';
import { PublishComponent } from './publish/publish.component';
import { CustomertestComponent } from './customertest/customertest.component';


@NgModule({
  declarations: [
    AppComponent,
    RaviSliderComponent,
    RaviNavbarComponent,
    TestimonialsComponent,
    ContactUsComponent,
    HomeComponent,
    GalleryComponent,
    FadeInDirectiveDirective,
    RaviNavbarComponent,
    ContactformComponent,
    FooterComponent,
    HomeServicesComponent,
    WorkComponent,
    SplitPipe,
    RestPipe,
    TruncatePipe,
    PublishComponent,
    CustomertestComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [{provide: LocationStrategy, useClass: PathLocationStrategy}],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
